import { UNIFIED_MENU } from '../config/subscriptionConfig';

/**
 * Normalize sidebar preferences from any format to the new { user, admin } structure.
 *
 * Accepted inputs:
 * - New format: { user: { hidden, order, subOrder }, admin: { hidden, order, subOrder } }
 * - Old format: { hidden, order, subOrder } — treated as admin preferences
 * - Empty/null — both sections empty
 */
export function normalizeSidebarPreferences(prefs) {
  const empty = { hidden: [], order: [], subOrder: {} };
  if (!prefs || Object.keys(prefs).length === 0) {
    return { user: { ...empty }, admin: { ...empty } };
  }
  if (prefs.user || prefs.admin) {
    return {
      user: prefs.user || { ...empty },
      admin: prefs.admin || { ...empty },
    };
  }
  // Old format — treat as admin prefs
  return {
    user: { ...empty },
    admin: {
      hidden: prefs.hidden || [],
      order: prefs.order || [],
      subOrder: prefs.subOrder || {},
    },
  };
}

/**
 * Set of menu item IDs that belong to the "user" section of UNIFIED_MENU
 * (everything before the separator-admin).
 */
const USER_ITEM_IDS = new Set();
for (const item of UNIFIED_MENU) {
  if (item.id === 'separator-admin') break;
  USER_ITEM_IDS.add(item.id);
}

/**
 * Check if a menu item ID belongs to the user section (before separator-admin).
 */
export function isUserMenuItem(id) {
  return USER_ITEM_IDS.has(id);
}
